export interface Config {
  apiUrl: string;
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
  };
  stage: 'DEV' | 'STAGING' | 'PROD';
}

const config: Config = {
  apiUrl: process.env.API_URL,
  auth0: {
    domain: process.env.AUTH0_DOMAIN,
    clientId: process.env.AUTH0_CLIENT_ID,
    audience: process.env.AUTH0_AUDIENCE,
  },
  stage: process.env.STAGE as 'DEV' | 'STAGING' | 'PROD',
};

export default config; 